<template>
<section>
    <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
    </div>

    <div v-show="!loading" v-if="ready" class="content">
        <div class="box">
            <div class="box-body">
                <div class="tab-content">
                    <div class="collection_location_scroll">
                    <div id="details" class="tab-pane fade in active collection_location_inner">
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.firstName)">
                                            <label>First Name</label>
                                            <input required @input= "capitalizeFirstName()" v-model="user.firstName" class="form-control" type="text" name="firstName" placeholder="First Name" pattern="^[a-zA-Z]([a-zA-Z\s!@#]{0,24}[a-zA-Z])*$" />
                                            <field-messages name="firstName" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">This is required field</div>
                                                <div slot="pattern">
                                                    Alphabets are allowed and upto 25 characters.
                                                </div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group" :class="fieldClassName(formstate.lastName)">
                                            <label>Last Name</label>
                                            <input v-model="user.lastName" @input="capitalizeLastName()" class="form-control" type="text" name="lastName" placeholder="Last Name" pattern="^[a-zA-Z]([a-zA-Z\s!@#]{0,24}[a-zA-Z])*$" />
                                            <field-messages name="lastName" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="pattern">
                                                    Alphabets are allowed and upto 25 characters.
                                                </div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.email)" :custom="{ email: emailValidator }">
                                            <label>Email</label>
                                            <input required v-model="user.email" type="email" class="form-control" name="email" placeholder="Email" />
                                            <field-messages name="email" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">This is required field</div>
                                                <div slot="email">Email is invalid</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                    <!-- <div class="col-sm-6">
                                            <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.mobile)">
                                                <label>Mobile Number </label>
                                                <input required v-model="user.mobile" type="number" class="form-control" name="mobile" placeholder="mobile" />
                                                <field-messages name="mobile" show="$touched || $submitted" class="form-control-feedback">
                                                    <div slot="required">This is required field</div>
                                                </field-messages>
                                            </validate>
                                        </div> -->
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.role)">
                                            <label>User Role Type</label>
                                            <select required name="role" class="form-control" v-model="user.role" @change="getRolesPermission($event.target.value)">
                                                <option value="" disabled>Select User Role Type</option>
                                                <option v-for="role in roles" :selected="
                                  role && user.role && role._id === user.role
                                " :value="role._id" :key="role._id">{{ role.name }}</option>
                                            </select>
                                            <field-messages name="role" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">This is required field</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                    <!-- <div class="col-sm-6">
                                            <validate auto-label class="form-group" :class="fieldClassName(formstate.documents)">
                                                <label>Permissions</label><br />
    
                                                <div v-for="scope in computedAllPermissions">
                                                    <input type="checkbox" v-bind:id="`${scope.name}`" v-bind:value="`${scope._id}`" v-model="permissionsCheck" :disabled="
                                    !checkCurrentPermissionWillBeEnable(scope.name)
                                  " />
                                                    <label v-bind:for="`${scope.name}`">{{
                                  scope.name
                                }}</label>
                                                </div>
                                                <field-messages name="otherInfo" show="$touched || $submitted" class="form-control-feedback">
                                                </field-messages>
                                            </validate>
                                        </div> -->
                                </div>
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group" :class="fieldClassName(formstate.document1)">
                                            <label>User ID Proof 1</label>
                                            <input type="file" accept="image/png,image/jpeg,image/jpg,application/pdf" id="fileinput" @change="onDocumentchanged1" class="form-control" required name="proof_1" />
                                            <field-messages name="proof_1" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">
                                                    Please upload less than 5mb picture
                                                </div>
                                            </field-messages>
                                            <div class="border p-2 mt-3" v-if="
                                $route.params &&
                                  $route.params._id != '0' &&
                                  user.licenceFront
                              ">
                                                <a v-bind:href="user.licenceFront" target="_blank">
                                                    View
                                                </a>
                                            </div>
                                        </validate>
                                    </div>

                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group" :class="fieldClassName(formstate.document)">
                                            <label>User ID Proof 2</label>
                                            <input type="file" accept="image/png,image/jpeg,image/jpg,application/pdf" id="fileinput1" name="proof_2" class="form-control" @change="onDocumentchanged2" />
                                            <field-messages name="proof_2" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">
                                                    Please upload less than 5mb document
                                                </div>
                                            </field-messages>
                                            <div class="border p-2 mt-3" v-if="
                                $route.params &&
                                  $route.params._id != '0' &&
                                  user.licenceBack
                              ">
                                                <a v-bind:href="user.licenceBack" target="_blank">
                                                    View
                                                </a>
                                            </div>
                                        </validate>
                                    </div>
                                    <!-- <div v-if="user.role === 'driver' ? true : false"> 
                                            
                                        
                                        <div class="col-sm-6">
                                            <validate auto-label class="form-group" :class="fieldClassName(formstate.document)">
                                                <label>User ID (licenceFront)</label>
                                                <input type="file" id="fileinput" name="proof_3" class="form-control"
                                                    @change="onDocumentchanged" />
                                                <field-messages name="proof_3" show="$touched || $submitted"
                                                    class="form-control-feedback">
                                                    <div slot="required">Please upload less than 3mb document</div>
                                                </field-messages>
                                            </validate>
                                        </div>
    
                                        <div class="col-sm-6">
                                            <validate auto-label class="form-group" :class="fieldClassName(formstate.document)">
                                                <label>User ID Proof (licenceBack)</label>
                                                <input type="file" id="fileinput" name="proof_4" class="form-control"
                                                    @change="onDocumentchanged" />
                                                <field-messages name="proof_4" show="$touched || $submitted"
                                                    class="form-control-feedback">
                                                    <div slot="required">Please upload less than 3mb document</div>
                                                </field-messages>
                                            </validate>
                                        </div>
    
                                    </div> -->
                                </div>
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.mobile)">
                                            <label>Contact Number</label>
                                            <input required v-model="user.mobile" maxlength="10" type="string" class="form-control" name="mobile" placeholder="Contact" pattern="[78965][0-9]{9}" />
                                            <field-messages name="mobile" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">This is required field</div>
                                                <div slot="pattern">Numbers are allowed.</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                </div>
                                <div class="col-sm-12" v-if="showCityDetails">
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityName)">
                                            <label>City</label>
                                            <input type="text" name="cityName" maxlength="25" class="form-control" required v-model="user.cityName" @input="cityNameCheck()" placeholder="City Name" pattern="^[a-zA-Z]([a-zA-Z\s!@#]{0,24}[a-zA-Z])*$" />
                                            <field-messages name="cityName" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">
                                                    City Name is a required field
                                                </div>
                                                <div slot="pattern">
                                                    Alphabets/Numbers are allowed.
                                                </div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                </div>
                            </div>
                        </vue-form>

                        <div class="col-sm-12 text-right">
                            <router-link :to="{ name: 'Users' }">
                                <button class="mr-2 btn btn-default" type="button">
                                    Cancel
                                </button>
                            </router-link>
                            <button class="btn gradientbt" type="submit" @click="createUser" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && $route.params._id == '0'">
                                Save
                            </button>
                            <button class="btn gradientbt mr-5" type="submit" @click="updateUser" :disabled="!((formstate.$dirty || isFileChange || isCityNameEnabled) && (formstate.$valid ||isCityNameEnabled))" v-if="$route.params && $route.params._id != '0'">
                                Update
                            </button>
                        </div>

                        <div class="text-center row" style="margin-top: 10px"></div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>

</section>
</template>

    
    
<script>
import axios from "axios";
import UserPermissions from "./UserPermissions.vue";
import store from "../../../store";
import {
    authService,
    formService,
    fileService
} from "../../../services";
import {
    EVENTS
} from "../../../config";
import UsersVue from "./Users.vue";

export default {
    name: "UserCreate",
    components: {
        UserPermissions,
    },
    data() {
        return {
            newRole: "",
            isCityNameEnabled: false,
            showCityDetails: null,
            isFileChange: false,
            ready: false,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: "",
            EVENTS: EVENTS,
            max: 20,
            user: {
                role: "",
            },
            userGroupsUpdated: null,
            userPermissionsUpdated: null,
            roles: [],
            permissions: [],
            formstate: {},
            docs: new Map(),
            allPermissions: [],
            // permissionsCheck: [],
            role: ["Helper", "Driver", "Surveyor"],
            docs1: null,
            docs2: null,
            // mode: "",
            // roleId: "",
        };
    },
    computed: {
        computedUserScope() {
            if (typeof this.user.role !== "undefined") {
                var permissions = [];
                this.user.role.permissions.forEach((element) => {
                    permissions.push(element.permission.name);
                });
                return permissions;
            }
            return [];
        },
        computedAllPermissions() {
            return store.state.auth.permissions;
        },
    },
    methods: {
        emailValidator: formService.emailValidator,
        fieldClassName: formService.fieldClassName,
        capitalizeFirstLetter(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        },
        capitalizeFirstName() {
         
                this.user.firstName = this.capitalizeFirstLetter(this.user.firstName);

        },
        capitalizeLastName() {
                this.user.lastName = this.capitalizeFirstLetter(this.user.lastName);
        },

        getRolesPermission(role) {
            return this.$roleRepository
                .list()
                .then((response) => {
                    this.rolesss = response.data.docs;
                    let roleId = this.rolesss.filter((el) => el._id === role);
                    this.roleName = roleId[0].name;
                    if (this.roleName === "Super Admin") {
                        this.showCityDetails = false;
                        this.newRole = this.roleName;
                    } else {
                        this.showCityDetails = true;
                        this.newRole = this.roleName;
                    }
                })
                .catch((error) => {
                    this.$snotify.error("Get roles failed", "Error!");
                });
        },

        getRoles() {
            return this.$roleRepository
                .roleListLowerThanCurrentUserRank({
                    currentRank: store.state.auth.user.role.rank,
                })
                .then((response) => {
                    // let updateRoles = response.data && response.data.docs;
                    // this.roles = updateRoles.filter(role => role.name !== 'Driver' && role.name !== 'Helper' && role.name !== 'Surveyor');

                    let updateRoles = response.data && response.data.docs;
                    this.roles = updateRoles.filter((role) => {
                        if (role.rank <= 2) {
                            return role.name;
                        }
                    });
                    // if (this.mode == "edit") {
                    //     this.getRolesPermission(this.roleId)
                    //     let selectedRole = this.roles.filter(
                    //         (el) => el._id === this.roleId
                    //     );
                    //     this.roleName = selectedRole[0].role
                    //     if (selectedRole[0].role === "Super Admin") {
                    //         this.showCityDetails = false;
                    //     } else {
                    //         this.showCityDetails = true;
                    //     }
                    // }
                })
                .catch((error) => {
                    this.$snotify.error("Get roles failed", "Error!");
                });
        },
        onFilechanged(event) {
            this.file = event.target.files[0];
            this.user.document = event.target.files[0]["name"];
        },
        // onDocumentchanged(event) {
        //     if (event.target.name === "proof_1") {
        //         this.docs.set(1, event.target.files[0]);
        //     } else if (event.target.name === "proof_2") {
        //         );

        //         this.docs.set(2, event.target.files[0]);
        //     }
        //     // this.docs = event.target.files[0];
        //     // this.user.document1 = event.target.files[0]['name'];
        // },

        onDocumentchanged1(event) {
            const fileinput = document.getElementById("fileinput");
            if (
                ["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(
                    event.target.files[0]["type"]
                )
            ) {
                if (event.target.files[0].size > 1024 * 1024 * 1) {
                    this.$snotify.error("File Size max limit of 1 MB", "Error!");
                    fileinput.value = "";
                    event.preventDefault();
                    return;
                } else {
                    this.docs1 = event.target.files[0];
                    this.helperAndDriver.idProof = event.target.files[0]["name"];
                }
            } else {
                this.$snotify.error("Upload png,jpeg,jpg,pdf files", "Error!");
                fileinput.value = "";
            }
        },
        onDocumentchanged2(event) {
            const fileinput = document.getElementById("fileinput");
            if (
                ["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(
                    event.target.files[0]["type"]
                )
            ) {
                if (event.target.files[0].size > 1024 * 1024 * 1) {
                    this.$snotify.error("File Size max limit of 1 MB", "Error!");
                    fileinput.value = "";
                    event.preventDefault();
                    return;
                } else {
                    this.docs2 = event.target.files[0];
                    this.helperAndDriver.idProof = event.target.files[0]["name"];
                }
            } else {
                this.$snotify.error("Upload .png, .jpeg, .jpg, .pdf files", "Error!");
                fileinput.value = "";
            }
        },

        // async uploadDocument() {
        //     let docsArr = [];
        //     for (let i = 1; i <= this.docs.size; i++) {
        //         docsArr.push(this.docs.get(i));
        //     }
        //     const response = await fileService.fileUpload(docsArr, {
        //         headers: {
        //             'Content-Type': 'multipart/form-data',
        //         },
        //     })
        //     return response.data;
        // },

        // async uploadDocument1() {
        //     let docsArr = [];
        //     docsArr.push(this.docs1);
        //     const response = await fileService.fileUpload(docsArr, {
        //         headers: {
        //             'Content-Type': 'multipart/form-data',
        //         },
        //     })
        //     return response.data;
        // },
        // async uploadDocument2() {
        //     let docsArr = [];
        //     docsArr.push(this.docs2);
        //     const response = await fileService.fileUpload(docsArr, {
        //         headers: {
        //             'Content-Type': 'multipart/form-data',
        //         },
        //     })
        //     return response.data;
        // },

        // uploadDocument(docId) {
        //     let formData = new FormData();
        //     if (this.file) {
        //         formData.append('file', this.file);
        //     }
        //     if (this.docs) {
        //         formData.append('file', this.docs);
        //     }
        //     formData.append('model', 'user');
        //     formData.append('docId', docId);
        //     axios
        //         .post('fileUpload', formData, {
        //             headers: {
        //                 'Content-Type': 'multipart/form-data',
        //             },
        //         })
        //         .then(res => {
        //         })
        //         .catch(function () {
        //             this.$snotify.error('Upload document failed', 'Error!');
        //         });
        // },
        //    onRoleSelection (event) {
        //         this.permissionsCheck.splice(0);
        //         this.roles.forEach(element => {
        //             if (element._id == event.target.value) {
        //                 let checkedPermissions = store.state.auth.scope.filter(value =>
        //                     element.permissions.includes(value.id),
        //                 );
        //                 checkedPermissions.forEach(element => {
        //                     this.permissionsCheck.push(element.id);
        //                 });
        //             }
        //         });
        //     },
        checkCurrentPermissionWillBeEnable(name) {
            if (typeof store.state.auth.scope !== "undefined") {
                const checkPermissionname = (obj) => obj.name === name;
                return store.state.auth.scope.some(checkPermissionname);
            }
        },
        async createUser() {
            this.loading = true;
            let documents = {};
            // if (uploadedFileLocation.length > 2) {
            //     documents['idFront'] = uploadedFileLocation[0].Location
            //     documents['idBack'] = uploadedFileLocation[1].Location
            //     documents['licenceFront'] = uploadedFileLocation[2].Location
            //     documents['licenceBack'] = uploadedFileLocation[3].Location
            // } else {
            //     documents['idFront'] = uploadedFileLocation[0].Location
            //     documents['idBack'] = uploadedFileLocation[1].Location
            // }
            this.user = {
                ...this.user,
                ...documents,
            };
            if (this.docs1 != null) {
                let uploadedFileLocation = await this.uploadDocument1();
                if (uploadedFileLocation !== "") {
                    this.user["licenceFront"] = uploadedFileLocation[0].Location;
                }
            }
            if (this.docs2 != null) {
                let uploadedFileLocation = await this.uploadDocument2();
                if (uploadedFileLocation !== "") {
                    this.user["licenceBack"] = uploadedFileLocation[0].Location;
                }
            }
            return authService
                .addUser(this.user)
                .then((response) => {
                    this.loading = false;
                    this.disabled = true;
                    this.$snotify.success(
                        `The ${this.user.firstName} has been added successfully.`,
                        response
                    );
                    this.$router.push("/users");
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.data.message == "Mobile Number already in use.") {
                        var errorMessage = "Contact Number is Already Exist!";
                        this.$snotify.error(errorMessage, "Error!");
                    } else if (error.data.message == "Email already in use.") {
                        var errorMessage = "Email Id is Already Exist!";
                        this.$snotify.error(errorMessage, "Error!");
                    } else if (error.data.message == "City already exist with different user.") {
                        var errorMessage = "City already exist with different user!";
                        this.$snotify.error(errorMessage, "Error!");
                    } else {
                        this.$snotify.error("User Create Failed.", "Error!");
                    }

                });
        },
        async updateUser() {
            this.loading = true;
            // this.user.mobile = String(this.user.mobile);
            delete this.user.otp;
            delete this.user.otpExpireTime;
            delete this.user.isOtpVerify;

            if (this.docs1 != null) {
                let uploadedFileLocation = await this.uploadDocument1();
                if (uploadedFileLocation !== "") {
                    this.user["licenceFront"] = uploadedFileLocation[0].Location;
                }
            }
            if (this.docs2 != null) {
                let uploadedFileLocation = await this.uploadDocument2();
                if (uploadedFileLocation !== "") {
                    this.user["licenceBack"] = uploadedFileLocation[0].Location;
                }
            }
            if (this.oldUser.roleName === "City Admin" && this.newRole === "Super Admin") {
                delete this.user.cityId;
                delete this.user.cityName;
            }
            if (this.oldUser.roleName === "Super Admin" && this.newRole === "City Admin") {
                delete this.user.cityId;
            }
            if (this.oldUser.roleName === "Super Admin" && !this.newRole) {
                delete this.user.cityId;
                delete this.user.cityName;
            }
            // this.user["cityId"] = this.user.cityId._id;
            if (this.user.licenceFront == null) {
                delete this.user.licenceFront;
            }
            if (this.user.licenceBack == null) {
                delete this.user.licenceBack;
            }

            // delete this.user.cityId
            delete this.user.roleName;
            return authService
                .updateUser(this.user)
                .then((response) => {
                    this.loading = false;
                    this.$snotify.success(
                        `The ${this.user.firstName} has been Updated successfully.`
                    );
                    this.$router.push("/users");
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.data.error) {
                        this.$snotify.error(error.data.message, "Error!");
                    } else {
                        this.$snotify.error("Update user failed", "Error!");
                    }
                });
        },

        onDocumentchanged1(event) {
            const fileinput = document.getElementById("fileinput");
            if (
                ["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(
                    event.target.files[0]["type"]
                )
            ) {
                if (event.target.files[0].size > 1024 * 1024 * 1) {
                    this.$snotify.error("File Size max limit of 1 MB", "Error!");
                    fileinput.value = "";
                    event.preventDefault();
                    return;
                } else {
                    this.docs1 = event.target.files[0];
                    if (this.docs1) {
                        this.isFileChange = true;
                    } else {
                        this.isFileChange = false;
                    }
                }
            } else {
                this.$snotify.error("Upload png,jpeg,jpg,pdf files", "Error!");
                fileinput.value = "";
            }
        },
        onDocumentchanged2(event) {
            const fileinput = document.getElementById("fileinput1");
            if (
                ["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(
                    event.target.files[0]["type"]
                )
            ) {
                if (event.target.files[0].size > 1024 * 1024 * 1) {
                    this.$snotify.error("File Size max limit of 1 MB", "Error!");
                    fileinput.value = "";
                    event.preventDefault();
                    return;
                } else {
                    this.docs2 = event.target.files[0];
                    if (this.docs2) {
                        this.isFileChange = true;
                    } else {
                        this.isFileChange = false;
                    }
                }
            } else {
                this.$snotify.error("Upload .png, .jpeg, .jpg, .pdf files", "Error!");
                fileinput.value = "";
            }
        },

        async uploadDocument1() {
            let docsArr = [];
            docsArr.push(this.docs1);
            const response = await fileService.fileUpload(docsArr, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        },
        async uploadDocument2() {
            let docsArr = [];
            docsArr.push(this.docs2);
            const response = await fileService.fileUpload(docsArr, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        },

        updatePermissions(permissions) {
            this.user.permissions = permissions;
        },
        getUser() {
            // const params = {
            //             $embed: ['cityId']
            //         };
            this.loading = true;
            // this.mode = "edit";

            return authService
                .getUser(this.$route.params._id)
                .then((response) => {
                    this.user = response.data;
                    this.user["cityName"] =
                        response.data.cityId != null ? response.data.cityId.cityName : null;
                    this.user["roleName"] =
                        response.data.role != null ? response.data.role.name : null;
                    this.user["role"] =
                        response.data.role != null ? response.data.role._id : null;
                    // this.user['roleName'] = response.data.role.name;
                    // this.user['role'] = response.data.role._id;                    
                    this.oldUser = _.cloneDeep(this.user);
                    this.user['cityId'] = response.data.cityId ? response.data.cityId._id : null;
                    this.$store.dispatch(
                        "setBreadcrumbTitle",
                        this.user.firstName + " " + this.user.lastName
                    );
                    if (this.user.roleName === "City Admin") {
                        this.showCityDetails = true;
                    }

                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error("Update user failed", "Error!");
                });
        },

        getUserPermisssions() {},

        clearChanges() {
            this.user = _.cloneDeep(this.oldUser);
            this.formstate._reset();
        },
        cityNameCheck() {
            this.isCityNameEnabled = true;
        }
    },
    created() {
        const promises = [];
        this.loading = true;

        promises.push(this.getRoles());
        if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
            promises.push(this.getUser());
        }
        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch(() => {
                this.loading = false;
                this.$snotify.error("Create user failed", "Error!");
            });
    },
    beforeDestroy() {},
};
</script>
    
    
<style scoped>
.required-field>label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red;
}

.gradientbt {
    background: #0f6940;
    color: white;
}

.box-body {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>



// WEBPACK FOOTER //
// UserCreate.vue?399725f6